export const SET_CLOSING = "SET_CLOSING";

const initialState = {
    closingData: {
        status: false,
        cashAmount: 0,
        balanceCashAmount: 0,
        cardAmount: 0,
        balanceCardAmount: 0,
        upiAmount: 0,
        balanceUpiAmount: 0,
        walletAmount: 0,
        balanceWalletAmount: 0,
        grandTotal: 0,
        balanceGrandTotal: 0,
        expense: []
    }
}
const ClosingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CLOSING:
            return ({ ...state, closingData: action.value, timestamp: Date.now() })
        default:
            return state;
    }
}
export default ClosingReducer;